import React from 'react';
import classNames from 'classnames';
import styles from './checkbox.module.scss';
import { MaterialIcon } from '../material-icon/MaterialIcon';

type Props = {
  checked: boolean;
  disabled?: boolean;
  onClick: () => void;
  size: string;
  dataTestE2e?: string;
};

export class Checkbox extends React.Component<Props> {
  static defaultProps = {
    size: 'default',
    disabled: false,
    checked: false,
    onClick: () => {},
  };

  render() {
    const { size, checked, onClick, disabled, dataTestE2e } = this.props;
    return (
      <span
        className={classNames(styles.container, {
          [styles.checked]: checked,
          [styles.defaultType]: size === 'default',
          [styles.largeType]: size === 'large',
          [styles.disabled]: disabled,
        })}
        onClick={disabled ? () => false : onClick}
        data-test-e2e={dataTestE2e}
      >
        {checked && <MaterialIcon name="check" />}
      </span>
    );
  }
}
